import { Button, Card, CardContent, Grid, IconButton, Tooltip, Typography } from '@mui/material';
import React from 'react';
import './contract-details.ui.scss';
import { ContractDto } from '../../../../services/dtos/contract.dto';
import LinkOffIcon from '@mui/icons-material/LinkOff';
import { BillDto } from '../../../../services/dtos/bill.dto';
import { FileDownload, Payment } from '@mui/icons-material';
import { Link } from 'react-router-dom';
import imgMeterReading from '../../../../assets/images/je-releve-mon-compteur.png';
import imgUpdateAddress from '../../../../assets/images/updateAddress.png';
import imgDemenagement from '../../../../assets/images/demenage.jpeg';
import imgEmmenagement from '../../../../assets/images/emmenage.png';
import { CreditCard, CalendarMonth, Payments, CreditCardOff } from '@mui/icons-material';

//Props du component
type Props = {
    contract?: ContractDto; // Contrat à afficher
    handleDettachContract: any; // handler pour détacher un contrat
    lastBill?: BillDto; // Dernière facture
    handleClickBills: any; // handler pour voir les factures
    handleStopDirectDebit: any; // handler pour arreter le prélévement automatique
    handleClickDownload: (contractId: string, billRef: string) => void;
};

/**
 * Composant comportant les détails d'un contrat
 * @param contract Le contrat affiché
 * @param handleDettachContract Handler qui permet de gérer le détachement d'un contrat
 * @param lastBill dernière facture
 * @param handleClickBills action click sur voir factures
 * @param handleStopDirectDebit handler pour arreter le prélévement automatique
 * @param handleClickDownload handler pour télécharger une facture
 * @constructor
 */
function ContractDetailsUi({
    contract,
    handleDettachContract,
    lastBill,
    handleClickBills,
    handleStopDirectDebit,
    handleClickDownload,
}: Props) {
    const getPaiement = (bill: BillDto) => {
        if (bill) {
            if (
                (bill.facture.etat_paiement === 'Facture non soldée' ||
                    (bill.facture.etat_paiement === '' &&
                        new Date(bill.facture.date_emission) > new Date('2025-04-07'))) &&
                bill.facture.urlPaiement !== null
            ) {
                return (
                    <>
                        <Tooltip title={'Payer ma facture'} arrow>
                            <IconButton href={bill.facture.urlPaiement} target={'_blank'} data-testid={'badge-payment'}>
                                <Payment />
                            </IconButton>
                        </Tooltip>
                    </>
                );
            }
        }
    };

    return (
        //Ensemble des éléments du détail d'un contrat
        <Grid container spacing={2} className={'containerDetails'}>
            {/*Item pour adresse de correspondance et bénéficiaire*/}
            <Grid item md={6} xs={12}>
                {/*Si mode mobile : pas de restriction de taille*/}
                <Card sx={{ height: { xs: 'flex', md: 300 } }}>
                    <CardContent>
                        <Grid container spacing={3}>
                            <Grid item xs={12}>
                                {/* Infos abonné */}
                                <Typography variant={'h5'}>Bénéficiaire et adresse :</Typography>
                                <Typography variant={'body1'}>
                                    {contract?.informations?.abonne?.nom} {contract?.informations?.abonne?.prenom}{' '}
                                    {contract?.informations?.abonne?.complementNom}
                                </Typography>
                                {/* Adresse du site/compteur */}
                                {contract?.adresseCompteur && (
                                    <Typography variant={'body1'}>
                                        {contract?.adresseCompteur?.adresse_complete ||
                                            `${contract?.adresseCompteur?.numero || ''} ${
                                                contract?.adresseCompteur?.rue || ''
                                            }, ${contract?.adresseCompteur?.code_postal || ''} ${
                                                contract?.adresseCompteur?.ville || ''
                                            }`.trim()}
                                    </Typography>
                                )}
                            </Grid>
                            <Grid item xs={12}>
                                {/* Infos payeur */}
                                {contract?.informations?.payeur && (
                                    <>
                                        <Typography variant={'h5'}>Payeur et adresse :</Typography>
                                        <Typography variant={'body1'}>
                                            {contract?.informations?.payeur?.nom}{' '}
                                            {contract?.informations?.payeur?.prenom}{' '}
                                            {contract?.informations?.payeur?.complementNom}
                                        </Typography>
                                        {/*Adresse du payeur*/}
                                        <Typography variant={'body1'}>
                                            {contract?.informations?.payeur?.adresse}
                                        </Typography>
                                    </>
                                )}
                            </Grid>
                        </Grid>
                    </CardContent>
                </Card>
            </Grid>
            {/*Item pour infos du contrat*/}
            <Grid item md={6} xs={12}>
                {/*Si mode mobile : pas de restriction de taille*/}
                <Card sx={{ height: { xs: 'flex', md: 300 } }}>
                    <CardContent>
                        <Grid container spacing={3}>
                            <Grid item xs={12}>
                                <Typography variant={'h5'}>
                                    {/* Eau // Assainissement */}
                                    Nature du contrat : {contract?.informations?.abonne?.typeContrat}
                                </Typography>
                            </Grid>
                            <Grid item xs={12}>
                                {/*pdiReference*/}
                                <Typography variant={'body1'} sx={{ fontWeight: 'bold' }}>
                                    Numéro d'abonnement :
                                </Typography>
                                <Typography variant={'body1'}>
                                    {' '}
                                    {contract?.informations?.abonne?.pdiReference}
                                </Typography>
                                {/*date debut de contrat*/}
                                <Typography variant={'body1'} sx={{ fontWeight: 'bold' }}>
                                    Date de début de contrat :
                                </Typography>
                                <Typography variant={'body1'}>
                                    {contract?.informations?.abonne?.debutContrat
                                        ? new Date(contract?.informations?.abonne?.debutContrat).toLocaleDateString()
                                        : ''}
                                </Typography>
                                {/*etablissement libelle*/}
                                <Typography variant={'body1'} sx={{ fontWeight: 'bold' }}>
                                    Structure de gestion :
                                </Typography>
                                <Typography variant={'body1'}>
                                    {contract?.informations?.abonne?.etablissementLibelle}
                                </Typography>
                            </Grid>
                        </Grid>
                    </CardContent>
                </Card>
            </Grid>
            {/*Partie dernière facture*/}
            <Grid item md={6} xs={12}>
                {/*Affichage de la dernière facture*/}
                {/*Si mode mobile : pas de restriction de taille*/}
                {lastBill ? (
                    <Card sx={{ height: { xs: 'flex', md: 300 } }}>
                        <CardContent>
                            <Grid container spacing={3}>
                                <Grid item xs={10}>
                                    <Typography variant={'h5'}>Informations facture :</Typography>
                                </Grid>
                                <Grid item sx={{ display: 'flex', justifyContent: 'center' }} xs={2}>
                                    <Tooltip title={'Télécharger la facture'} arrow>
                                        <IconButton
                                            data-testid="get-content-button"
                                            onClick={() =>
                                                handleClickDownload(
                                                    lastBill.facture.contractId,
                                                    lastBill.facture.reference
                                                )
                                            }
                                        >
                                            <FileDownload />
                                        </IconButton>
                                    </Tooltip>
                                </Grid>
                                <Grid item xs={12}>
                                    {/*reference facture*/}
                                    <Typography variant={'body1'} sx={{ fontWeight: 'bold' }}>
                                        Dernière facture :
                                    </Typography>
                                    <Typography variant={'body1'}> {lastBill?.facture.reference}</Typography>
                                    {/*date d'émission*/}
                                    <Typography variant={'body1'} sx={{ fontWeight: 'bold' }}>
                                        Emise le :
                                    </Typography>
                                    <Typography variant={'body1'}>
                                        {new Date(lastBill?.facture.date_emission).toLocaleDateString()}
                                    </Typography>
                                    {/*Affichage du montant*/}
                                    {/*Si a prelever et urlPaiement présent*/}
                                    {/*Affichage d'un lien pour payer*/}
                                    <Typography variant={'body1'} sx={{ fontWeight: 'bold' }}>
                                        Montant :
                                    </Typography>
                                    <Typography variant={'body1'}>
                                        {lastBill?.facture.montant_ttc + '€'}
                                        {getPaiement(lastBill)}
                                    </Typography>
                                    {/*bouton pour voir toutes les factures*/}
                                    <Typography variant={'body1'} sx={{ textAlign: 'right' }}>
                                        {lastBill?.facture?.echeances?.length &&
                                        lastBill?.facture?.echeances?.length > 0 ? (
                                            /* Bouton de relève de compteur*/
                                            <Button
                                                component={Link}
                                                variant="text"
                                                sx={{ margin: 1 }}
                                                to={'/contrat/' + contract?.['@id'] + '/echeances'}
                                                startIcon={<CalendarMonth style={{ marginRight: 5, width: '25px' }} />}
                                            >
                                                Voir mon échéancier
                                            </Button>
                                        ) : (
                                            ''
                                        )}
                                        <Button sx={{ margin: 1 }} onClick={handleClickBills} variant="contained">
                                            Voir toutes les factures
                                        </Button>
                                    </Typography>
                                </Grid>
                            </Grid>
                        </CardContent>
                    </Card>
                ) : (
                    ''
                )}
            </Grid>
            {/* Partie services */}
            <Grid item md={6} xs={12}>
                {/*Si mode mobile : pas de restriction de taille*/}
                <Card sx={{ height: { xs: 'flex', md: contract?.mensualise ? 350 : 300 } }}>
                    <CardContent>
                        <Grid container spacing={0.5}>
                            <Grid item xs={12}>
                                <Typography variant={'h5'}>Mes Services</Typography>
                            </Grid>
                            <Grid item xs={12}>
                                {/* Bouton de détachement du contrat*/}
                                <Button
                                    variant="text"
                                    data-testid="box-detachedContract"
                                    onClick={handleDettachContract}
                                    startIcon={<LinkOffIcon color="error" style={{ marginRight: 5, width: '25px' }} />}
                                >
                                    Détacher mon contrat
                                </Button>
                            </Grid>
                            {'EAU POTABLE' === contract?.informations?.abonne?.typeContrat && (
                                <Grid item xs={12}>
                                    {/* Bouton de relève de compteur*/}
                                    <Button
                                        component={Link}
                                        variant="text"
                                        to={'/contrat/' + contract?.['@id'] + '/releve-mon-compteur'}
                                        startIcon={
                                            <img
                                                style={{ width: '25px', marginRight: 5, borderRadius: '50%' }}
                                                src={imgMeterReading}
                                                alt="Je relève mon compteur"
                                            />
                                        }
                                    >
                                        Je relève mon compteur
                                    </Button>
                                </Grid>
                            )}

                            <Grid item xs={12}>
                                {/* Bouton de changer mon adresse de correspondance*/}
                                <Button
                                    variant="text"
                                    component={Link}
                                    to={'/contrat/' + contract?.['@id'] + '/nouvelle-adresse-contrat'}
                                    startIcon={
                                        <img
                                            style={{ width: '25px', marginRight: 5, borderRadius: '50%' }}
                                            src={imgUpdateAddress}
                                            alt="Changer mon adresse de correspondance"
                                        />
                                    }
                                >
                                    Changer mon adresse de correspondance
                                </Button>
                            </Grid>
                            <Grid item xs={12}>
                                {/* Bouton de déménagement */}
                                <Button
                                    component={Link}
                                    to={'/contrat/' + contract?.['@id'] + '/demenage'}
                                    startIcon={
                                        <img
                                            style={{ width: '25px', marginRight: 5, borderRadius: '50%' }}
                                            src={imgDemenagement}
                                            alt="Je déménage"
                                        />
                                    }
                                >
                                    Je déménage
                                </Button>
                            </Grid>
                            <Grid item xs={12}>
                                {/* Bouton de déménagement */}
                                <Button
                                    component={Link}
                                    to={'/j-emmenage'}
                                    startIcon={
                                        <img
                                            style={{ width: '25px', marginRight: 5, borderRadius: '50%' }}
                                            src={imgEmmenagement}
                                            alt="J'emméménage"
                                        />
                                    }
                                >
                                    J'emménage
                                </Button>
                            </Grid>
                            {contract?.mensualise ? (
                                // Bouton changement de coordonnées bancaires
                                <Grid item xs={12}>
                                    <Button
                                        variant="text"
                                        data-testid="box-changeDirectDebit"
                                        startIcon={<CreditCard style={{ marginRight: 5 }} />}
                                        component={Link}
                                        to={`/contrat/${contract?.['@id']}/prelevement-automatique`}
                                        state={{ mensualise: true }}
                                    >
                                        Changer de coordonnées bancaires
                                    </Button>
                                </Grid>
                            ) : null}
                            <Grid item xs={12}>
                                {contract?.mensualise ? (
                                    // Bouton stopper prélèvement mensuel
                                    <Button
                                        variant="text"
                                        data-testid="box-stopDirectDebit"
                                        onClick={handleStopDirectDebit}
                                        startIcon={<CreditCardOff color="error" style={{ marginRight: 5 }} />}
                                    >
                                        Arrêter le prélèvement mensuel
                                    </Button>
                                ) : (
                                    contract?.mensualisable && (
                                        // Bouton opter prélèvement mensuel
                                        <Button
                                            variant="text"
                                            component={Link}
                                            to={'/contrat/' + contract?.['@id'] + '/prelevement-automatique'}
                                            startIcon={<Payments style={{ marginRight: 5 }} />}
                                        >
                                            Opter pour le prélèvement mensuel
                                        </Button>
                                    )
                                )}
                            </Grid>
                        </Grid>
                    </CardContent>
                </Card>
            </Grid>
        </Grid>
    );
}

export default ContractDetailsUi;
